export default __webpack_public_path__ + "static/corner-90cd036c24b7043e2d4dc480896ca819.png";